export default __webpack_public_path__ + "static/media/ui_icon_comment_small.1c941bef.svg";